import { render, staticRenderFns } from "./AddFilterView.vue?vue&type=template&id=5bb7407d&"
import script from "./AddFilterView.vue?vue&type=script&lang=js&"
export * from "./AddFilterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports